import * as React from 'react'
import type {
  FilterPanelCheckItem,
} from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'
import FilterPanelCheckboxGroup from 'components/Common/FilterPanel/FilterPanelCheckboxGroup'

interface Props {
  items: Array<FilterPanelCheckItem>
  onFilterChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  selectedItems: Set<string>
}

function FlightSingleFilterAirlines(props: Props) {
  const { items, onFilterChange, selectedItems } = props

  return (
    <FilterPanelCheckboxGroup
      name="airlines"
      items={items}
      onChange={onFilterChange}
      selected={selectedItems}
      maxItems={5}
    />
  )
}

export default FlightSingleFilterAirlines
